
import { autoLengthDefault } from "./AutoLength";
import { Length } from "./Length";
import { LengthType } from "./LengthType";
import { LengthValueMillimeter } from "./LengthValueMillimeter";
import RangeLength from "./RangeLength";
import { StarLength } from "./StarLength";

const starRegexPattern = /^\d*\*$/;
const rangeRegexPattern = /^\d+-\d+:\d+\/\d*$/;

export  class LengthParser {
    static parse(text: string): Length | null {
        if (!text) return null;
    
        if (!isNaN(Number(text))) {
            return new LengthValueMillimeter(Number(text));
        }
    
        if (text === "Auto" || text === "auto" ) {
            return autoLengthDefault;
        }
    
        let match = text.match(starRegexPattern);
        if (match) {
            const value = match[0] === '*' ? 1 : parseInt(match[0]);
            return new StarLength(value);
        }
    
        match = text.match(rangeRegexPattern);
        if (match) {
            const [range, params] = text.split(':');
            const [start, stop] = range.split('-').map(Number);
            const [defaultValue, step] = params.split('/').map(Number);
            return new RangeLength(start, stop, step || 1, defaultValue);
        }
    
        throw new Error(`The input value ${text} couldn't be parsed!`);
    }
}

